<div *ngIf="report">
    <div class="table overflow-scroll">
        <!-- Header row -->
        <div class="custom-row header">
            <div class="cell" *ngFor="let label of report.reportData.labels">{{ label }}</div>
        </div>
        <!-- Data rows -->
        <div class="custom-row" *ngFor="let row of report.reportData.content; let i = index">
            <div class="cell" *ngFor="let cell of row" [ngClass]="{'bg-lightgrey': i % 2 === 0}">
                {{ cell }}
            </div>
        </div>
    </div>
</div>